import _ from 'lodash';

export const findFirstErrorField = (fields, submitErrors) => {
  for (let key of Object.keys(fields)) {
    if (!_.isNil(_.get(submitErrors, key, null))) {
      return key;
    }
  }
};
